import React, { useState, useEffect } from "react";
import style from "./Login.module.css";
import LoginImg from "../../assests/loginnew.png.png";
import PatnerLoginImg from "../../assests/patnerlogin.png";
import LogoDashboard from "../../assests/logo-dashboard.png";
import { useNavigate } from "react-router-dom";
import { encryptJsonData } from "../EncryptionUtils"; // Adjust path if necessary
import { baseurl, getPostAuthRedirectPath } from "../Url";
import { ROLE_004, ROLE_005 } from "../../constants/roles";
import { logActivity } from "../../services/activityService";
import { RxEyeOpen, RxEyeClosed } from "react-icons/rx";
import { auth, googleProvider } from "../Firebase";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";
import Switch from "react-switch";

function Login() {
  const UserID = localStorage.getItem("USERID");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1); // 1: Email, 2: OTP
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState(false);
  const [emailForReset, setEmailForReset] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const isMentor = false;


  const navigate = useNavigate();
  const isPatnerRoute = typeof window !== "undefined" && window.location.pathname.startsWith("/patner");

  useEffect(() => {
    if (!import.meta.env.VITE_FIREBASE_API_KEY) {
      console.error("VITE_FIREBASE_API_KEY is missing in .env file!");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("authPortal", isPatnerRoute ? "patner" : "member");
  }, [isPatnerRoute]);

  useEffect(() => {
    if (popup || emailSent) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [popup, emailSent]);

  // Capture referral data (skill_id + ref_code) from URL when landing on Login
  useEffect(() => {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const skillId = params.get("skill_id");
    const refCode = params.get("ref_code");

    if (!skillId && !refCode) return;

    if (refCode) {
      localStorage.setItem("duno_referral_code", refCode);
    }
    if (skillId) {
      localStorage.setItem("duno_referral_asset_id", skillId);
      localStorage.setItem("duno_referral_asset_category", "SKILL");
    }
  }, []);

  async function handleSendOtp(e) {
    if (e) e.preventDefault();
    setLoading(true);
    setMessage("");

    const body = { Email: email, is_mentor_login: isMentor };

    try {
      const response = await fetch(`${baseurl}/account/send-login-otp`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();

      if (data.status === "success") {
        logActivity({ module: "AUTH", action: "OTP_SENT", instance: email, remark: "Login OTP sent" });
        navigate("/email/verification", { state: { Email: email, mode: "login", isMentor: isMentor } });
      } else {
        setMessage(data.message || "Failed to send OTP");
      }
    } catch (err) {
      setMessage("Error connecting to server");
    } finally {
      setLoading(false);
    }
  }

  async function handleVerifyOtp(e) {
    if (e) e.preventDefault();
    setLoading(true);
    setMessage("");

    const body = { email: email, otp: otp };

    try {
      const response = await fetch(`${baseurl}/otp/validate/user`, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();

      if (data.status === true) {
        const userData = data.data[0] || data.data;
        localStorage.setItem("access-token", JSON.stringify(userData.access_token));
        localStorage.setItem("ClubID", userData.club_id);
        localStorage.setItem("ORGID", userData.org_id);
        localStorage.setItem("USERID", userData.user_id);
        localStorage.setItem("mentor", userData.is_mentor);
        localStorage.setItem("roleId", isPatnerRoute ? ROLE_005 : ROLE_004);
        localStorage.setItem("role", isPatnerRoute ? "patner" : "intern");
        localStorage.setItem("username", userData.Username);

        logActivity({ module: "AUTH", action: "LOGIN_SUCCESS", instance: userData.user_id, remark: "OTP login successful" });
        setMessage("Login Successful!");
        setTimeout(() => navigate(getPostAuthRedirectPath(userData.user_id)), 1000);
      } else {
        setMessage(data.description || "Invalid OTP");
      }
    } catch (err) {
      setMessage("Error verifying OTP");
    } finally {
      setLoading(false);
    }
  }

  async function googleLogin() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const googleIdToken = credential.idToken;
      const referralCode =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_code")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_code"));
      const referralAssetCategory =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_category")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_category"));
      const referralAssetId =
        (typeof window !== "undefined" && window.localStorage.getItem("duno_referral_asset_id")) ||
        (typeof window !== "undefined" && window.sessionStorage.getItem("duno_referral_asset_id"));

      const body = {
        credential: googleIdToken,
        name: result.user.displayName,
        email: result.user.email,
        ...(referralCode && { referral_code: referralCode }),
        ...(referralAssetCategory && { referral_asset_category: referralAssetCategory }),
        ...(referralAssetId && { referral_asset_id: referralAssetId })
      };
      const newdata = JSON.stringify(body);
      const encryptstring = encryptJsonData(newdata);
      await fetch(`${baseurl}/account/login/googleverification`, {
        method: "POST",
        body: JSON.stringify({
          keys: encryptstring,
          is_mentor_login: isMentor
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Google Login Response:", data);
          if (data.status === "success") {
            // Strictly enforce Intern role. If user is a mentor, deny login.
            if (data.data.is_mentor === true) {
              setMessage("You are a Mentor. Please login via the Mentor Login page.");
              return;
            }

            localStorage.setItem(
              "access-token",
              JSON.stringify(data.data.access_token)
            );
            localStorage.setItem("ClubID", data.data.club_id);
            localStorage.setItem("ORGID", data.data.org_id);
            localStorage.setItem("USERID", data.data.user_id);
            localStorage.setItem("mentor", data.data.is_mentor);
            localStorage.setItem("roleId", isPatnerRoute ? ROLE_005 : ROLE_004);
            localStorage.setItem("role", isPatnerRoute ? "patner" : (isMentor ? "mentor" : "intern"));
            localStorage.setItem("username", result.user.displayName || data.data.username);
            logActivity({ module: "AUTH", action: "LOGIN_SUCCESS", instance: data.data.user_id, remark: "Google login successful" });
            navigate(getPostAuthRedirectPath(data.data.user_id));
          } else {
            setMessage(data.message || "Google Login Failed");
          }
        })
        .catch((err) => {
          console.error("Google Login Error:", err);
          setMessage("An error occurred during Google Login");
        });
    } catch (error) {
      console.error("Firebase Google Login Error:", error);
      setMessage("Google Login Failed");
    }
  }

  async function forgetPassWord() {
    await fetch(`${baseurl}/forgot/pwd`, {
      method: "POST",
      body: JSON.stringify({
        email: emailForReset,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.status === true || data.status === "success") {
          setPopup(false);
          setEmailSent(true);
        } else {
          setEmailError("Didn't find any account with that email");
        }
      });
  }

  return (
    <div className={style.Container}>
      {isPatnerRoute && (
        <header className={style.patnerHeader}>
          <img src={LogoDashboard} alt="Duno Club Logo" className={style.patnerHeaderLogo} />
        </header>
      )}
      <div className={`${style.loginBody} ${isPatnerRoute ? style.patnerLoginBody : ""}`}>
        <div className={`${style.loginBodyLeft} ${isPatnerRoute ? style.patnerLoginBodyLeft : ""}`}>
          <div className={style.formBox}>
            <div className={style.welcomeTxt}>
              <p className={style.welcomeHead}>
                Welcome to <span>Duno Club</span>
              </p>
              <p className={style.welcomeSubHead}>
                Learnings ! Fun ! Opportunities !
              </p>
            </div>

            <div className={style.formContainer}>
              <form onSubmit={step === 1 ? handleSendOtp : handleVerifyOtp} autoComplete="off">
                <div className={style.formFeilds}>
                  {step === 1 ? (
                    <div className={style.EmailBox}>
                      <input
                        type="email"
                        placeholder="Enter your Email"
                        name="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  ) : (
                    <div className={style.EmailBox}>
                      <input
                        type="text"
                        placeholder="Enter OTP sent to your email"
                        name="otp"
                        required
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </div>
                  )}



                  {message && (
                    <div className={style.errorMessage}>
                      {message}
                    </div>
                  )}
                </div>



                <button type="submit" disabled={loading}>
                  {loading ? "Processing..." : step === 1 ? "Send OTP" : "Login"}
                </button>

                {step === 2 && (
                  <div className={style.signUp} style={{ marginTop: "1rem" }}>
                    <p>Didn't receive OTP? <span onClick={handleSendOtp}>Resend</span></p>
                    <p><span onClick={() => setStep(1)}>Back to Email</span></p>
                  </div>
                )}

                <div className={style.OR}>OR</div>

                <div className={style.Google}>
                  <button type="button" className={style.googleBtn} onClick={googleLogin}>
                    <FcGoogle size={26} style={{ backgroundColor: "white", borderRadius: "50%" }} />
                    Sign in with Google
                  </button>
                </div>

                <div className={style.signUp}>
                  <p>New to DUNO CLUB?</p>
                  <p>
                    <span onClick={() => navigate(isPatnerRoute ? "/patner/register" : "/register")}>Sign up</span>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className={`${style.loginBodyRight} ${isPatnerRoute ? style.patnerLoginBodyRight : ""}`}>
          <div className={`${style.groupImg} ${isPatnerRoute ? style.patnerGroupImg : ""}`}>
            <img src={isPatnerRoute ? PatnerLoginImg : LoginImg} alt="Login" />
          </div>
        </div>
      </div>

      {popup && (
        <>
          <div className={style.overlay} />
          <div className={style.popup}>
            <p>Enter your account email to receive a password reset link</p>
            <input
              value={emailForReset}
              onChange={(e) => setEmailForReset(e.target.value)}
              placeholder="Email"
              required
            />
            {emailError && <p className={style.errorMessage}>{emailError}</p>}
            <div className={style.popupButton}>
              <button
                className={style.popupSend}
                onClick={() => {
                  if (emailForReset) forgetPassWord();
                }}
              >
                Send
              </button>
              <button
                className={style.popupCancel}
                onClick={() => setPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </>
      )}

      {emailSent && (
        <>
          <div className={style.overlay} />
          <div className={style.popup}>
            <p>Please check your email for a reset link.</p>
            <div className={style.popupButton}>
              <button onClick={() => setEmailSent(false)}>OK</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Login;
